import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Lock, Trash2, Clock } from 'lucide-react';
import { CATEGORIES, TOOLS } from '../lib/tools';
import { useI18n } from '../contexts/I18nContext';

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-vault-paper/40 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <ShieldCheck className="w-6 h-6 text-vault-gold" />
              <span className="font-heading font-bold text-xl">ValutDocu</span>
            </div>
            <p className="text-gray-400 text-sm max-w-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-4 mt-6">
              <div className="flex items-center gap-1.5 text-xs text-gray-400">
                <Lock className="w-3.5 h-3.5 text-vault-gold" /> 256-bit SSL
              </div>
              <div className="flex items-center gap-1.5 text-xs text-gray-400">
                <Trash2 className="w-3.5 h-3.5 text-vault-gold" /> Auto-delete
              </div>
              <div className="flex items-center gap-1.5 text-xs text-gray-400">
                <Clock className="w-3.5 h-3.5 text-vault-gold" /> 60-min TTL
              </div>
            </div>
          </div>

          {CATEGORIES.slice(0, 3).map((cat) => (
            <div key={cat}>
              <h4 className="font-heading font-semibold text-sm text-white mb-4 tracking-tight">{cat}</h4>
              <ul className="space-y-2">
                {TOOLS.filter((t2) => t2.category === cat).slice(0, 5).map((t2) => (
                  <li key={t2.slug}>
                    <Link
                      to={`/${t2.slug}`}
                      className={`text-xs ${t2.available ? 'text-gray-400 hover:text-vault-gold' : 'text-gray-600'} transition`}
                    >
                      {t2.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500 font-mono">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className="flex gap-6 text-xs text-gray-500">
            <Link to="/blog" className="hover:text-vault-gold">{t('nav.blog')}</Link>
            <Link to="/" className="hover:text-vault-gold">{t('footer.privacy')}</Link>
            <Link to="/" className="hover:text-vault-gold">{t('footer.terms')}</Link>
            <Link to="/" className="hover:text-vault-gold">{t('footer.security')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
